module.exports = __webpack_public_path__ + "img/analytics.110b30a6.svg";